import * as yup from "yup"
import { formReminderSchema } from "./FormReminder"
import { formSalesOrderDetailSchema } from "./FormSalesOrderDetail"

export type FormSalesOrderType = yup.InferType<typeof formSalesOrderSchema>

export const formSalesOrderSchema = yup.object().shape({
  sales_order_id: yup.number().label("Sales Order").optional(),
  customer_id: yup
    .number()
    .label("Customer")
    .typeError("Customer is required")
    .required(),
  customer_name: yup.string().label("Customer").optional(),
  employee_id: yup
    .number()
    .label("Employee")
    .typeError("Employee is required")
    .required(),
  payment_term: yup
    .number()
    .label("Payment Term")
    .typeError("Please fill Customer Payment Term")
    .required("Please fill Customer Payment Term"),
  payment_term_name: yup.string().label("Payment Term").optional(),
  price_level_name: yup
    .string()
    .label("Price Level")
    .required("Please fill Customer Price Level"),
  location_id: yup
    .number()
    .label("Location")
    .typeError("Location is required")
    .required(),
  tax_inclusive: yup.boolean().label("Tax Inclusive").required(),
  shipped: yup.string().label("Shipped").required(),
  memo: yup.string().label("Memo").required(),
  trx_code: yup.string().label("Code").optional(),
  transaction_date: yup.string().label("Transaction Date").required(),
  referensi: yup.string().label("Referensi").required(),
  promize_date: yup.string().label("Promise Date").required(),
  freight: yup.number().label("Freight").optional(),
  approved_by: yup.string().label("Approved By").optional(),
  approved_by_name: yup.string().label("Approved By").optional(),
  approval_status: yup.number().label("Approved By").defined(),
  approval_status_text: yup.string().label("Approved By").defined(),
  so_payment_status: yup.number().label("Payment Status").optional(),
  so_payment_status_text: yup.string().label("Payment Status").optional(),
  sodetail: yup
    .array()
    .of(formSalesOrderDetailSchema)
    .min(1)
    .label("Sales order detail")
    .required(),
  reminder: formReminderSchema.nullable()
})
